<script lang="ts" setup>
import { useHead } from '@vueuse/head'
import { computed, onMounted } from 'vue'

import { useSourcepointStore } from '@toni/rendering/src/stores/sourcepoint'

import ContentPass from '../../content-pass/ContentPass.vue'
import GoogleTagManager from '../../tracking/components/GoogleTagManager.vue'
import { generateMetas } from '../../utils/meta'
import { MetaData } from '../../utils/meta-data-schema'
import { PageMeta } from '../../utils/page-meta-schema'

const sourcepointStore = useSourcepointStore()

onMounted(() => {
  // Call the consentActionPerformed method when interaction with CMP first layer is completed
  window.__tcfapi?.('addEventListener', 2, async (tcData: unknown, success: boolean): Promise<void> => {
    if (success && tcData.eventStatus === 'useractioncomplete') {
      sourcepointStore.consentActionPerformed()
    }
  })
})

const props = defineProps<{
  metaData: MetaData,
  pageMeta: PageMeta
}>()
const metaData = computed(() => props.metaData)
const pageMeta = computed(() => props.pageMeta)

const metaInfo = generateMetas(sourcepointStore.consentConfig, metaData.value, pageMeta.value)

useHead(metaInfo)
</script>

<template>
  <slot />
  <GoogleTagManager />
  <ContentPass />
</template>
